module.exports = __webpack_public_path__ + "assets/f0a64a99c6fe487ae440ce046724f347.mp3";